<div class="main-content">
    <router-outlet></router-outlet>
</div>
<div class="container">
    <app-footer></app-footer>
</div>
